  /* Primary brand and accent colors */
  //--color-primary: #091DF2;              /* For anchor buttons, primary buttons, icons, etc. */
  //--color-primary-text: #FFFFFF;         /* Text color on primary buttons */

  /* Secondary and supporting brand colors */
  //--color-heading: var(--color-heading);              /* For main headings */
  //--color-heading-rgb: 15, 19, 71;       /* For overlay effects (login/forgot screens) */

  /* Neutral and text colors */
  //--color-text-body: #666984;            /* Paragraph and secondary text color */
  //--color-border: #D1DAEB;               /* Input border color */

  /* Backgrounds */
  //--color-bg-light: #FFFFFF;             /* Light background surfaces */
const defaultTheme = {
  body: {
    font_family: "Inter, sans-serif",
    font_size: "",
    color: "#111827",
  },
  colors: {
    primary: "#091DF2",
    primary_text: "#FFFFFF",
    heading: "#0F1347",
    heading_rgb: "15, 19, 71",
    text_body: "#666984",
    border: "#D1DAEB",
    bg_light: "#FFFFFF",
  },
};

export default defaultTheme;
